import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'common/components/Modal';
import Button from 'common/components/Button';
import styles from './index.module.css';

const RegulatoryConsentModal = ({ isOpen, isSubmitting, onAccept }) => (
  <div className={styles.root}>
    <Modal
      isOpen={isOpen}
      closeOnClickOutside={false}
      closeOnEscape={false}
      modalClassName={styles.modalOverride}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>Regulatory update</h2>
        <div className={styles.content}>
          <p>
            As part of our proactive approach to upcoming regulatory changes, we
            are preparing for the implementation of the{' '}
            <span className={styles.emphasis}>
              Markets in Crypto-Assets (MiCA)
            </span>{' '}
            regulation, which is being implemented across the European Union.
          </p>
          <br />
          <p>
            Currently, our group operates under different regulatory licenses,
            including entities established in{' '}
            <span className={styles.emphasis}>Estonia</span> and{' '}
            <span className={styles.emphasis}>Portugal</span>. In anticipation
            of MiCA’s enforcement, we are aligning our internal structure to
            ensure a seamless transition and uninterrupted service delivery.
          </p>
          <br />
          <p>
            To that end, we would like to inform you that we are preparing to
            designate{' '}
            <span className={styles.emphasis}>
              another entity from the group
            </span>{' '}
            – a regulated entity within our group that will hold the appropriate
            MiCA license – as the future service provider for certain
            crypto-related services.
          </p>
          <br />
          <p>
            <span className={styles.emphasis}>
              At this stage, no operational changes will take place,
            </span>{' '}
            and your current services will continue as usual. However, to ensure
            a smooth and efficient transition when the time comes, we kindly
            request your consent to:
          </p>
          <br />
          <ul className={styles.list}>
            <li>
              <span className={styles.emphasis}>Share relevant data</span>{' '}
              between the current service provider and the other entity from the
              group, in full compliance with applicable data protection laws;
              and
            </li>
            <li>
              <a
                className={styles.link}
                href="https://www.xmoney.com/legal"
                target="_blank"
                rel="noopener noreferrer"
              >
                Accept CIFRA&apos;s Terms and Conditions
              </a>{' '}
              in advance, which will govern the provision of services under the
              MiCA framework when the transition occurs.
            </li>
          </ul>
          <br />
          <p>
            These preparatory steps will allow us to act promptly and without
            disruption once the regulatory environment requires such changes.
          </p>
        </div>
        <div className={styles.actions}>
          <Button kind="primary" onClick={onAccept} loading={isSubmitting}>
            <button type="button">Agree and go to dashboard</button>
          </Button>
        </div>
      </div>
    </Modal>
  </div>
);

RegulatoryConsentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
};

RegulatoryConsentModal.defaultProps = {
  isSubmitting: false,
};

export default RegulatoryConsentModal;
